// import Vue from 'vue'
import axios from 'axios'
// const country = 86 // 中国
const platform = 3 // 网页版
const appid = 1
const cache = 1 // 三方登录时不传 uniqid subid
const baseUrl = ''

export default {
  // 发送通用 post 请求
  request (url, params) {
    // Vue.prototype.$http.post = Vue.prototype.$http.get // test
    return new Promise((resolve, reject) => {
      axios.post(url, params).then(res => {
        // if (typeof res.data === 'string') res.data = JSON.parse(res.data) // test
        if (res.status === 200 && res.data.code === 0) {
          resolve(res.data.data)
        } else {
          reject(res.data)
        }
      }, res => {
        reject(res.data)
      }).catch(err => {
        console.log(err)
      })
    })
  },
  // 通用获取图片验证码
  getImgCaptcha (url) {
    return new Promise((resolve, reject) => {
      axios.get(url, {
        headers: { 'Base64': 1 }
      }).then(res => {
        resolve(res) // 图片验证码直接是res.data拿到字符串
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 免密登录
  // smslogin (country, cellphone, code, ucode = '') {
  //   return this.request(`${baseUrl}/account/sms/login`, {
  //     country,
  //     cellphone,
  //     code,
  //     ucode,
  //     platform,
  //     appid
  //   })
  // },
  // 用手机号和密码登录**
  // signin (country, phone, password, captcha, remember) {
  //   return this.request(`${baseUrl}/account/ticket/login`, {
  //     country: country,
  //     cellphone: phone,
  //     password: password,
  //     captcha: captcha || '',
  //     remember,
  //     platform,
  //     appid
  //   })
  // },

  // 带密码注册**
  // signup (country, nickname, cellphone, password, code, captcha) {
  //   return this.request(`${baseUrl}/account/register/save`, {
  //     country,
  //     nickname,
  //     cellphone,
  //     password,
  //     captcha: captcha || '',
  //     platform,
  //     appid,
  //     code
  //   })
  // },
  // 免密快速注册
  // quicksignup (country, cellphone, nickname, code, ucode = '') {
  //   return this.request(`${baseUrl}/account/register/quick`, {
  //     country,
  //     cellphone,
  //     nickname,
  //     code,
  //     ucode,
  //     platform,
  //     appid
  //   })
  // },

  // 初始化密码
  // initpwd (password) {
  //   return this.request(`${baseUrl}/account/user/init`, {password})
  // },

  // 获取关联的公司
  // getRelatedCompany () {
  //   return this.request(`${baseUrl}/account/user/esinfo`, {})
  // },

  // 获取电话列表**
  // getCellphoneList () {
  //   return new Promise((resolve, reject) => {
  //     axios.get(`${baseUrl}/account/cellphone/list`).then(res => {
  //       if (res.status === 200 && res.data.code === 0) {
  //         resolve(res.data.data)
  //       } else {
  //         reject(res.data)
  //       }
  //     }).catch(err => {
  //       reject(err)
  //     })
  //   })
  // },

  // 获取用户信息**
  // getUserInfo () {
  //   return this.request(`${baseUrl}/account/user`, {})
  // },

  // 验证是否已验证身份，有权修改密码和手机
  // verifierUser () {
  //   return this.request(`${baseUrl}/account/user/verifier`)
  // },

  // 通过短信验证用户身份
  // verifierUserCode (code) {
  //   return this.request(`${baseUrl}/account/cellphone/verifier`, {
  //     code
  //   })
  // },

  // 发送注册短信验证码**
  sendRegSMS (country, phone, captcha) {
    return this.request(`${baseUrl}/account/register/code`, {
      country: country,
      cellphone: phone,
      captcha: captcha || ''
    })
  },

  // 获取忘记密码短信验证码**
  sendForgotSMS (country, phone, captcha) {
    return this.request(`${baseUrl}/account/forgot/code`, {
      country: country,
      cellphone: phone,
      captcha: captcha
    })
  },

  // 验证忘记密码短信验证码，验证通过后调用 resetPassword 重置密码**
  verifyforgotSMS (country, phone, code) {
    return this.request(`${baseUrl}/account/forgot/verifier`, {
      country: country,
      cellphone: phone,
      code: code
    })
  },

  // 设置新密码**
  resetPassword (password) {
    return this.request(`${baseUrl}/account/forgot/reset`, {
      password: password
    })
  },

  // 获取注册图形验证码**
  getRegCaptcha () {
    return new Promise((resolve, reject) => {
      axios.get(`${baseUrl}/account/captcha/register`, {
        headers: {
          'Base64': 1
        }
      }).then(res => {
        resolve(res) // 图片验证码直接是res.data拿到字符串
      }).catch(err => {
        reject(err)
      })
    })
  },

  // 获取忘记密码图形验证码**
  getForgotCaptcha () {
    return new Promise((resolve, reject) => {
      axios.get(`${baseUrl}/account/captcha/forgot`, {
        headers: {
          'Base64': 1
        }
      }).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },

  // 获取登录图形验证码**
  getSigninCaptcha () {
    return new Promise((resolve, reject) => {
      axios.get(`${baseUrl}/account/captcha/ticket`, {
        headers: {
          'Base64': 1
        }
      }).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },

  // 修改密码**
  modifyPassword (oldPassword, newPassword) {
    return this.request(`${baseUrl}/account/user/password`, {
      password: oldPassword,
      newpassword: newPassword
    })
  },

  // 获取用户的行业，职位
  getInfoList () {
    return this.request(`${baseUrl}/account/info/user`)
  },

  // 修改用户资料，单个修改**
  modifyProfile (key, value) {
    let param = {}
    param[key] = value
    return this.request(`${baseUrl}/account/user/update`, param)
  },

  // 修改头像 ~~
  uploadAvatar (avatar) {
    return new Promise((resolve, reject) => {
      axios.post(`${baseUrl}/account/user/avatar`, { avatar }, {
        withCredentials: true,
        headers: {
          'Base64': 1
        }
      }).then(res => {
        if (res.status === 200 && res.data.code === 0) {
          resolve(res.data.data)
        } else {
          reject(res.data)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },

  // 修改手机号第一步验证密码接口**
  newMobileVerify (password, captcha) {
    return this.request(`${baseUrl}/account/cellphone/password`, {
      password: password,
      captcha: captcha
    })
  },

  // 验证密码多次获取图片验证码**
  getNewMobileVerifyCaptcha () {
    return new Promise((resolve, reject) => {
      axios.get(`${baseUrl}/account/captcha/password`, {
        headers: {
          'Base64': 1
        }
      }).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },

  // 发送更换新手机短信验证码**
  sendNewMobileSMS (country, phone, captcha) {
    return this.request(`${baseUrl}/account/cellphone/newcode`, {
      country: country,
      cellphone: phone,
      captcha: captcha
    })
  },

  // 获取更换新手机图形验证码**
  getNewMobileCaptcha () {
    return new Promise((resolve, reject) => {
      axios.get(`${baseUrl}/account/captcha/newcellphone`, {
        headers: {
          'Base64': 1
        }
      }).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },

  // 更新新手机号**
  updateNewMobile (country, phone, code) {
    return this.request(`${baseUrl}/account/cellphone/update`, {
      country: country,
      cellphone: phone,
      code: code
    })
  },

  // 三方登录绑定时发送短信验证码**
  sendPlatformBindSMS (country, type, cellphone, captcha) {
    return this.request(`${baseUrl}/account/bind/code`, {
      country, type, cellphone, captcha, cache
    })
  },

  // 获取第三方登录状态，就是扫描后跳转回来的操作**
  getBindState (type) {
    return this.request(`${baseUrl}/account/bind/ticket`, {
      type,
      platform,
      appid,
      cache
    })
  },

  // 获取绑定手机图形验证码,需要传入type => wechat qq weibo **
  getBindCaptcha (type) {
    return new Promise((resolve, reject) => {
      axios.get(`${baseUrl}/account/captcha/${type}`, {
        headers: {
          'Base64': 1
        }
      }).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },

  /**
   * 完成三方登录绑定或注册
   * @param uniqid
   * @param subid
   * @param type
   * @param country
   * @param cellphone
   * @param code
   * @param avatar
   * @param nickname
   * @param platform
   * @param appid
   */
  bindPlatformBind (country, cellphone, code, type, ucode = '') {
    return this.request(`${baseUrl}/account/bind/bind`, {
      country,
      cellphone,
      code,
      type,
      appid,
      ucode,
      cache,
      platform,
      registe: 1
    })
  },

  // 填写密码完成三方登录绑定
  signupPlatformBind (type, password) {
    return this.request(`${baseUrl}/account/bind/password`, {
      cache, type, password, platform, appid
    })
  },

  // 解绑并重新绑定新的第三方账号
  rebindPlatformBind (type) {
    return this.request(`${baseUrl}/account/bind/rebind`, {
      type, cache, platform, appid
    })
  },

  // 获取登录用户第三放绑定信息，注意这个是在个人中心处获取
  bindedInfo () {
    return this.request(`${baseUrl}/account/user/binded`)
  },

  // 在个人中心解除第三方绑定信息
  unbind (uniqid, type) {
    return this.request(`${baseUrl}/account/user/unbind`, {
      uniqid, type
    })
  },

  // 登出接口
  logout () {
    return this.request(`${baseUrl}/account/ticket/delete`)
  },

  // 优惠券
  coupon (params) {
    return this.request(`${baseUrl}/serv/v1/user/coupon`, params)
  }
}
